import { render, staticRenderFns } from "./UiModalError.vue?vue&type=template&id=5892fe4b&"
import script from "./UiModalError.vue?vue&type=script&lang=js&"
export * from "./UiModalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports